module.exports = __webpack_public_path__ + "img/anba.54c28fd0.jpg";